var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ExpandOnOverflowList',{ref:"expandOnOverflow",attrs:{"row":_vm.row,"column":_vm.column},scopedSlots:_vm._u([{key:"no-records",fn:function(){return [_vm._v("\n    "+_vm._s(_vm.$t('userTeamsField.no_records'))+"\n  ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }